import { isNone, Maybe } from '@crocodille/common';
import { RefObject } from 'react';

import {
  useEventListener,
  UseEventListenerOptions,
} from './use-event-listener';

export function useClickOutside<T extends HTMLElement>(
  elementRef: RefObject<Maybe<T>>,
  handler: (event: MouseEvent) => void,
  options?: UseEventListenerOptions,
) {
  useEventListener(
    'click',
    (event) => {
      if (isNone(elementRef.current)) {
        return;
      }

      const target = event.target;

      if (!(target instanceof Element)) {
        return;
      }

      const targetWithinElement = elementRef?.current?.contains?.(target);

      //
      // If target is not within element, it must be in the document.
      // If not in the document the target was removed as part of the interaction,
      // and is only present because the event carries a reference to it.
      //
      if (!targetWithinElement && document.contains(target)) {
        handler(event);
      }
    },
    typeof window !== 'undefined' ? document : null,
    options,
  );
}
